// Reducer for managing pvl document data in the Redux store.
import {
  GET_PENSION_VERIFICATION_LIST,
  GET_PENSION_VERIFICATION_LIST_SUCCESS,
  GET_PENSION_VERIFICATION_LIST_FAILURE,
  GET_PENSION_VERIFICATION,
  GET_PENSION_VERIFICATION_SUCCESS,
  GET_PENSION_VERIFICATION_FAILURE,
  POST_REGENERATE_PENSION_VERIFICATION,
  POST_REGENERATE_PENSION_VERIFICATION_SUCCESS,
  POST_REGENERATE_PENSION_VERIFICATION_FAILURE,
} from './constant';

const initialState = {
  getPensionVerificationListData: [],
  getPensionVerificationData: null,
  token: null,
  isPensionVerificationListError: false,
  isPensionVerificationError: false,
  isRegeneratePensionVerificationError: false,
  isRegeneratePensionVerificationLoading: false,
  error: {},
  loading: true,
};

const PensionVerificationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PENSION_VERIFICATION_LIST:
      return {
        ...state,
        token: payload.token,
        isPensionVerificationListError: false,
        loading: true,
      };
    case GET_PENSION_VERIFICATION_LIST_SUCCESS: {
      return {
        ...state,
        getPensionVerificationListData: payload.data,
        // Temporarily getting the Users full name from this payload. We will eventually get this from a different API.
        customerFullName:
          payload.data && Array.isArray(payload.data) && payload.data[0]?.customerDetails?.customerFullName
            ? payload.data[0].customerDetails.customerFullName
            : '',
        isPensionVerificationListError: false,
        loading: false,
      };
    }
    case GET_PENSION_VERIFICATION_LIST_FAILURE:
      return {
        ...state,
        error: payload.error,
        isPensionVerificationListError: true,
        loading: false,
      };
    case GET_PENSION_VERIFICATION:
      return {
        ...state,
        loading: true,
        isPensionVerificationError: false,
      };

    case GET_PENSION_VERIFICATION_SUCCESS:
      return {
        ...state,
        getPensionVerificationData: payload.data,
        loading: false,
      };

    case GET_PENSION_VERIFICATION_FAILURE:
      return {
        ...state,
        error: payload.error,
        isPensionVerificationError: true,
        loading: false,
      };
    case POST_REGENERATE_PENSION_VERIFICATION:
      return {
        ...state,
        token: payload.token,
        isRegeneratePensionVerificationError: false,
        isRegeneratePensionVerificationLoading: true,
      };
    case POST_REGENERATE_PENSION_VERIFICATION_SUCCESS:
      return {
        ...state,
        isRegeneratePensionVerificationError: false,
        isRegeneratePensionVerificationLoading: false,
      };
    case POST_REGENERATE_PENSION_VERIFICATION_FAILURE:
      return {
        ...state,
        error: payload.error,
        isRegeneratePensionVerificationError: true,
        isRegeneratePensionVerificationLoading: false,
      };
    case 'RESET_PENSION_PDF':
      return {
        ...state,
        getPensionVerificationData: null,
      };
    default:
      return state;
  }
};
export default PensionVerificationReducer;